<template>
  <content-loader v-if="showContentLoader" />
  <div class="page">
    <riseup-header />
    <div
      class="back-arrow-container"
      @click="handleBackClick"
    >
      <img
        src="../../assets/arrow_back.svg"
        alt="Back Arrow"
        class="back-arrow"
      >
    </div>
    <div class="content">
      <lottie-player
        src="https://static.letsriseup.com/lottie/high_five.json"
        autoplay
        loop
        class="animation"
      />
      <h1>Check your email!</h1>
      <div class="text">
        Your savings insights are on their way to you.
        <p>(This may take up to 5 minutes)</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useRoute } from 'vue-router';
import RiseupHeader from '../Common/RiseupHeader.vue';
import ContentLoader from '../Common/ContentLoader.vue';
import Segment from '../../Segment';
import useContentLoader from '../../composables/useContentLoader';
import config from '../../config';

const route = useRoute();
const {
  showContentLoader,
} = useContentLoader();

const handleBackClick = () => {
  Segment.trackUserGot('OtsSuccessBackClicked');
  window.location.href = config.get().otsLoginUrl;
};

onMounted(async () => {
  const queryParam = route.query || null;
  Segment.trackUserGot('OtsSuccessPageEntered', { fromEmail: queryParam ? queryParam.fromEmail : false });
});

</script>

<style lang="scss" scoped>
@import '../../scss/riseup-vars';

.content {
  overflow-y: auto;
  scroll-behavior: smooth;
  padding-left: 25px;
  padding-right: 25px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.page {
  background-color: $main_background_color;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.content h1 {
  padding-top: 20px;
  padding-bottom: 10px;
  color: #202125;
  font-size: 28px;
  font-family: GrenetteSemiBold;
  font-weight: 600;
  line-height: 39px;
  word-wrap: break-word
}

.content .text{
  // Check your email
  padding-top: 10px;
  color: #202125;
  font-size: 18px;
  font-family: CircularStdBook;
  font-weight: 450;
  line-height: 26px;
  width: 90%;
  word-wrap: break-word
}

.animation {
  width: 200px;
  height: 200px;
}

.back-arrow-container {
  padding: 21px;
  cursor: pointer;
}

.back-arrow {
  width: 24px;
  height: 24px;
}

.blue-button {
  background-color: #5D7AFD;
  border-radius: 10px;
  color: white;
  padding: 10px 20px;
  border: none;
  margin: 20px 0;
  width: 90%;
  cursor: pointer;
  font-size: 18px;
  font-family: CircularStdBook;
  font-weight: 700;
}

.footer {
  width: 100%;
  text-align: center;
  position: sticky;
  bottom: 0;
}

</style>
